<template>
<span>
  <v-select v-model="model" :items="values" :label="field.name" hint="Wybierz wartosci" item-text="name" item-value="code" persistent-hint></v-select>
  {{ description }}
</span>
</template>

<script>
import Context from '@/plugins/Context'
import http from '@/plugins/http'
import {
  observerField
} from '@/mixins/observerField'
import {
  input
} from '@/mixins/input'
export default {
  computed: {
    locale: () => process.env.VUE_APP_LOCALE,
    watchedValue: function() {
      if (this.watchedFieldInterface == undefined) {
        return undefined
      }
      return this.getParent().getFieldValue(this.watchedFieldInterface.id)
    }
  },
  data() {
    return {
      watchedFieldInterface: {},
      timeoutFunc: null,
      timeoutTime: 1000,
      values: [],
      oldValue: ""
    }
  },
  methods: {
    fetchFields(code) {
      if (code == undefined || code == "") return

      let data = this.$store.getters.relatedValues(this.field.options.group_type_id, code)
      if (data) {
        this.values = data.relatedValues
        return
      }

      this.$store.dispatch('loadRelatedValuesByCode', {
        'group_type_id': this.field.options.group_type_id,
        code
      }).then(data => this.values = data)

    },
    setNewTimeoutFunc(newVal) {
      if (newVal != this.oldValue) {
        this.oldValue = newVal
        clearTimeout(this.timeoutFunc)
        this.timeoutFunc = setTimeout(this.fetchFields.bind(this, newVal), this.timeoutTime)
      }
    }
  },
  created() {
    this.watchedFieldInterface = this.getParent().getFieldInfo(this.field.options['depend_field_id'])
  },
  mixins: [input],
  watch: {
    watchedValue: {
      handler: function(newVal, old) {
        if (newVal != undefined)
          this.setNewTimeoutFunc(newVal)
      },
      deep: true
    }
  }
}
</script>

<style>

</style>
